<!-- <div>
  <div *ngFor="let item of [].constructor(numRows); let row = index" 
    fxLayout="row" fxLayoutAlign="space-evenly" fxLayoutGap="10px grid" style="padding: 5px">
    <div *ngFor="let item of [].constructor(numCols); let col = index" 
      fxFlex fxLayout="column" fxLayoutAlign="center center">
      <button mat-icon-button class="color-button" 
        [mat-dialog-close]="colors[row*numCols+col]"
        [style.background]="colors[row*numCols+col]">
        <mat-icon style="vertical-align: baseline">{{ row*numCols+col == selectedColor ? 'done' : ''}}</mat-icon>
      </button>
    </div>
  </div>
</div> -->

<color-sketch [color]="selectedColor" [presetColors]="colors" [disableAlpha]="true" (onChangeComplete)="colorChanged($event)"></color-sketch>
